import React from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Tabs, Modal, Input, Divider, Upload, Icon, Table, Button, message } from 'antd'
import styles from './list.module.scss'
// import SelectOwner from './selectOwner'
import List from './List'
import * as apis from '@/apis'

const RetailBindingList = ({
  modal: {
    name,
  },
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => {
  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      footer={null}
      width={1200}
      style={{ top: 30 }}
      visible={isOpen}
      onCancel={hide}>
        <List {...ownProps} />
    </Modal>
  )
}

export default sagaModal({
  name: 'RETAIL_BINDING_LIST_DIALOG',
 })(RetailBindingList)
